import {computed, ref} from 'vue'
import {defineStore} from 'pinia'

type Screen = 'pre-call' | 'call' | 'end'

const initialState = window.__INITIAL_STATE__.app
const environment = window.getEnvironmentFromURL()

const getApiUrl = (endpoint: string, environment?: string) => {
  if (environment) {
    if (environment === 'prod') {
      return endpoint.replace('{{environment}}', '')
    } else {
      return endpoint.replace('{{environment}}', `${environment}.`)
    }
  }
  return endpoint
}

const getSessionDetailUrl = (endpoint: string, environment?: string) => {
  if (environment) {
    if (environment === 'prod') {
      return endpoint.replace('{{environment}}', '')
    } else {
      return endpoint.replace('{{environment}}', `${environment}.`)
    }
  }
  return endpoint
}

export default defineStore('app', () => {
  const isLoading = ref(false)
  const loadingMessage = ref('')
  const screen = ref<Screen>('pre-call')
  const isRequestingMedia = ref(false)
  // TODO: need ref?
  const isHmtDevice = ref(initialState.isHmtDevice)
  const isScreensharingSupported = ref(navigator.mediaDevices && 'getDisplayMedia' in navigator.mediaDevices)
  const idealConstraints = ref(initialState.idealConstraints)
  const roles = ref(initialState.roles)

  const isPreCall = computed(() => screen.value === 'pre-call')
  const isCall = computed(() => screen.value === 'call')
  const isEnd = computed(() => screen.value === 'end')

  const locize = {
    project: import.meta.env.VITE_LOCIZE_PROJECT,
    api: import.meta.env.VITE_LOCIZE_API_URL,
    version: import.meta.env.VITE_LOCIZE_VERSION,
    namespace: import.meta.env.VITE_LOCIZE_NAMESPACE,
  }

  const configuration = {
    app: {
      type: import.meta.env.VITE_APP_TYPE,
    },
    environment: environment,
    session: {
      api: getApiUrl(import.meta.env.VITE_SESSION_PROVIDER_API, environment),
      pinApi: getApiUrl(import.meta.env.VITE_SESSION_PIN_API, environment),
      notificationApi: getApiUrl(import.meta.env.VITE_NOTIFICATION_API, environment),
      detailUrl: getSessionDetailUrl(import.meta.env.VITE_SESSION_DETAIL_URL, environment),
    },
  }

  const languages = ref({})

  function loading(message = '') {
    isLoading.value = true
    loadingMessage.value = message
  }

  function loaded() {
    isLoading.value = false
  }

  function goToCall() {
    screen.value = 'call'
  }

  function goToEnd() {
    screen.value = 'end'
  }

  function setRequestingMedia(value: boolean) {
    isRequestingMedia.value = value
  }

  return {
    isLoading,
    loadingMessage,
    screen,
    isRequestingMedia,
    isHmtDevice,
    isScreensharingSupported,
    idealConstraints,
    roles,
    locize,
    configuration,
    languages,
    isPreCall,
    isCall,
    isEnd,
    loading,
    loaded,
    goToCall,
    goToEnd,
    setRequestingMedia,
  }
})
